import type { FunctionComponent } from "react";
import { useContext } from "react";

import { GalleryContext } from "scmp-app/components/image-gallery/contexts";

import CloseIcon from "./icons/icon-close.svg";
import { ToolbarButton } from "./toolbar-button";

export const ToolbarButtonClose: FunctionComponent = () => {
  const { instance } = useContext(GalleryContext);

  return (
    <ToolbarButton
      icon={<CloseIcon />}
      onClick={() => {
        instance?.close();
      }}
      title="Close"
    />
  );
};

ToolbarButtonClose.displayName = "ToolbarButtonClose";
